/* eslint-disable react/display-name  */
import * as React from "react"
import { useFetchCart, useCartActions } from "hooks"
import { toPersianMoney, toPersianDigits } from "utils"
import { Typography, Picture } from "components"
import { Button } from "reactstrap"
import { APICart } from "types/cart"
import { Link } from "react-router-dom"
import { ReactComponent as RemoveImage } from "media/svg/delete.svg"
import "./cartMini.scss"

interface CartMini {
	ref: React.Ref<HTMLDivElement>
	open: boolean
}

const CartMini: React.FC<CartMini> = React.forwardRef<HTMLDivElement, CartMini>(
	({ open }, ref) => {
		const { data, total } = useFetchCart()
		return (
			<>
				<div ref={ref} className={`cart-mini ${open ? "" : "d-none"}`}>
					{data.length !== 0 ? (
						<>
							<div className="d-flex align-items-center justify-content-between">
								<Typography
									className="cart-mini__price p-2"
									variant="body2"
								>
									مبلغ قابل پرداخت:{" "}
									<span className="text-coral-two">
										{toPersianMoney(total)} ریال
									</span>
								</Typography>
								<Link to="/cart">
									<Typography
										variant="body2"
										color="muted"
										className="text-decoration-none cart-mini__go-to-cart-btn px-2"
									>
										نمایش سبد خرید
									</Typography>
								</Link>
							</div>
							<div className="cart-mini__list">
								<CartList items={data} />
							</div>
							<Link to={{ pathname: "/cart", state: "shipping" }}>
								<Button
									color="jade"
									className="py-2 w-100 cart-mini__button"
								>
									پرداخت و ثبت سفارش
								</Button>
							</Link>
						</>
					) : (
						<Typography
							className="py-4"
							align="center"
							color="muted"
						>
							سبد خرید شما خالی است
						</Typography>
					)}
				</div>
			</>
		)
	}
)

const CartList: React.FC<{ items: APICart[] }> = ({ items }) => {
	return (
		<>
			{items.map((item) => (
				<CartListItem key={item.id} {...item} />
			))}
		</>
	)
}

const CartListItem: React.FC<APICart> = ({
	id,
	product_image,
	name_en,
	name_fa,
	quantity,
}) => {
	const { removeItem } = useCartActions()
	return (
		<div className="d-flex flex-row justify-content-start align-items-center">
			<button
				className="cart-mini__remove-button"
				onClick={() => removeItem(id)}
			>
				<RemoveImage />
			</button>
			<Picture
				className="cart-mini__image"
				src={`https://antivirus.ir/assets/images/small/${product_image}`}
				alt={name_en}
			/>
			<div className="d-flex flex-column">
				<Typography
					noWrap
					className="cart-mini__name text-truncate d-inline-block"
				>
					{name_fa}
				</Typography>
				<Typography className="cart-mini__name">
					{toPersianDigits(quantity)} عدد
				</Typography>
			</div>
		</div>
	)
}

export default CartMini
